import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fullName: {
    color: theme.palette.common.black,
    fontWeight: 500,
    fontSize: theme.spacing(2),
    lineHeight: "16px",
    textAlign: "right",
    paddingTop: theme.spacing(0.5),
    textTransform: "capitalize",
  },
  firstNameSkeleton: {
    width: 39,
    height: 12,
    marginRight: theme.spacing(0.5),
  },
  lastNameSkeleton: {
    width: 57,
    height: 12,
  },
}));

export default useStyles;
